/**
 * Функции для oauth. Открытие страниц, перезагрузка и тд
 * */
(function(){
    $("a[data-open-window]").on('click', function(e){
        let w = window.open($(this).data('open-window'));
        let t = setInterval(function() {
            if(w.closed) {
                clearInterval(t);
                window.location.reload();
            }
        }, 500);
    });
}());
